
import React from "react";
import OpportunityCard from "./OpportunityCard";
import { Opportunity } from "@/types/database-extensions";
import { Button } from "@/components/ui/button";
import { Plus, Briefcase } from "lucide-react";
import { User } from "@supabase/supabase-js";

interface OpportunitiesListProps {
  opportunities: Opportunity[];
  loading: boolean;
  onPostOpportunity: () => void;
  onDelete?: (id: string) => Promise<void>;
  currentUser?: User | null;
}

const OpportunitiesList: React.FC<OpportunitiesListProps> = ({
  opportunities,
  loading,
  onPostOpportunity,
  onDelete,
  currentUser
}) => {
  if (loading) {
    return (
      <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3, 4, 5, 6].map(i => (
          <div key={i} className="bg-gradient-to-br from-muted/50 to-muted/30 h-72 rounded-2xl animate-pulse border border-border/50"></div>
        ))}
      </div>
    );
  }

  if (opportunities.length === 0) {
    return (
      <div className="text-center py-20 bg-gradient-to-br from-orange-50/60 via-amber-50/40 to-orange-100/30 dark:from-gray-900/60 dark:via-orange-900/20 dark:to-amber-900/20 rounded-3xl border border-orange-200/40 dark:border-orange-800/30 backdrop-blur-sm shadow-lg">
        <div className="mx-auto h-24 w-24 bg-[#FF8C00] rounded-full flex items-center justify-center mb-8 shadow-xl">
          <Briefcase className="h-12 w-12 text-white" />
        </div>
        <h3 className="text-3xl font-bold mb-4 text-[#FF8C00] font-poppins">
          No opportunities found
        </h3>
        <p className="text-muted-foreground mb-10 max-w-lg mx-auto leading-relaxed text-lg font-medium">
          Be the first to post an amazing opportunity and help teens kickstart their careers!
        </p>
        <Button 
          onClick={onPostOpportunity}
          className="bg-[#FF8C00] hover:bg-[#FF7F00] text-white border-0 h-14 px-10 rounded-xl font-semibold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
        >
          <Plus size={20} className="mr-3" /> Post Opportunity
        </Button>
      </div>
    );
  }

  return (
    <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {opportunities.map(opportunity => (
        <div key={opportunity.id} className="transform hover:scale-105 transition-all duration-300">
          <OpportunityCard 
            opportunity={opportunity} 
            onDelete={onDelete}
            canDelete={!!currentUser && currentUser.id === opportunity.user_id}
          />
        </div>
      ))}
    </div>
  );
};

export default OpportunitiesList;
